import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";

export const NotificationLMSExamResult: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsExamResultInfo;

    if (!lmsInfo) return null;

    return <SimpleTitle>
        {` Экзамен завершен. Проекту `}
        <a href={CreateLinkTo.project(lmsInfo?.projectId)}>
            {lmsInfo?.projectTitle}
        </a>
        {` была выставлена оценка `}
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";

export const NotificationLMSExamResult: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsExamResultInfo;

    if (!lmsInfo) return null;

    return <SimpleTitle>
        {` Экзамен завершен. Проекту `}
        <a href={CreateLinkTo.project(lmsInfo?.projectId)}>
            {lmsInfo?.projectTitle}
        </a>
        {` была выставлена оценка `}
    </SimpleTitle>
}